import React from "react";
import { all, delay, put, race, select, take, takeLatest, call } from "redux-saga/effects";
import { resultDecisionGraph } from "@/common/hooks_useResultDecisionGraph";
import { selectFullRelease } from "@/redux/fullRelease/reducer";
import { actions } from "../slice";
import { debugPayloadUtils } from "../../../Debug/EEContext";
import { useDispatch } from "react-redux";
import { onReqToExportRawPayload, onReqToImportRawPayoad } from "./forRaw";
import { SagaActions, sagaACreators, sagaANames } from "./constants";
import { dataTreeItems, gatherAllIds } from "./dataTreeItems";
import * as forResetNS from "./forReset";

export function* saga(): Gen {
  const resetRef: { current: SagaActions[ "requestToEncloseReset" ][ "payload" ][ "reset" ] } = {
    current: console.log
  };

  yield all([

    takeLatest(sagaANames.requestToEncloseReset, function* onRequestToSetGoal(a: SagaActions[ "requestToEncloseReset" ]) {
      resetRef.current = a.payload.reset;
    }),
    takeLatest(sagaANames.requestToSetGoal, function* onRequestToSetGoal(a: SagaActions["requestToSetGoal"]) {
      yield put(actions.setGoal(a.payload.goalId));
      resetRef.current();
    }),
    takeLatest(sagaANames.requestToSetGoalIdAfterBatchCall, function* onRequestToSetGoalIdAfterBatchCall() {
      const { timeout, action } = yield race({
        timeout: delay(7_000),
        action: take("DCSVLY/BATCHCALL")
      });
      if (timeout) return;

      yield put(sagaACreators.requestToSetGoal({ goalId: action.payload.goal }));
    }),
    takeLatest("DCSVLY/BATCHCALL_SUCCESS", function* prepareDataTree(action: any) {
      const release = yield select(selectFullRelease);
      // the response's decision graph, or a legacy `graph`; without either the previous run's tree is cleared
      const items = dataTreeItems(resultDecisionGraph(action.payload, release ?? undefined));

      yield put(actions.setDataTreeItems(items));

      yield put(
        actions.setExpanded(
          gatherAllIds({ id: "", children: items, info: { text: "", value: "" } })
            .filter(Boolean),
        )
      );
    }),
    takeLatest(sagaANames.requestToExportRawPayload, onReqToExportRawPayload),
    takeLatest(sagaANames.requestToImportRawPayload, onReqToImportRawPayoad),
    call(forResetNS.saga)
  ]);
}


export const EncloseResetComp = React.memo(() => {
  const reset = debugPayloadUtils.useReset();
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(sagaACreators.requestToEncloseReset({ reset }));
  }, [reset]);

  return null;
});
EncloseResetComp.displayName = "batchDebug/redux/saga/EncloseReset/Comp";
